import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { ApiError, api } from "../lib/api";
const PLAN_ALLOWS = {
    starter: ["life"],
    pro: ["life", "health"],
    enterprise: ["life", "health", "annuities"],
};
const ENGINE_LABEL = {
    life: "Life Insurance",
    health: "Health Insurance",
    annuities: "Variable Annuities",
};
const ENGINE_DESC = {
    life: "Marriage, mortgage, obituary, birth & divorce triggers.",
    health: "WARN layoffs, new business formations, coverage gaps.",
    annuities: "SEC Form 4 sales, probate, UCC sales, pension terminations.",
};
export function EngineToggle({ tenant, toggle, stats, onChange, onUpgradeRequired }) {
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    const allowed = PLAN_ALLOWS[tenant.plan_tier].includes(toggle.engine_id);
    async function handleClick() {
        if (!allowed && !toggle.enabled) {
            onUpgradeRequired();
            return;
        }
        setPending(true);
        setError(null);
        const optimistic = { ...toggle, enabled: !toggle.enabled };
        onChange(optimistic);
        try {
            const updated = await api.setEngine(tenant.id, toggle.engine_id, optimistic.enabled);
            onChange(updated);
        }
        catch (e) {
            onChange(toggle); // revert
            const msg = e instanceof ApiError ? e.message : String(e);
            setError(msg);
        }
        finally {
            setPending(false);
        }
    }
    return (_jsxs("div", { className: `rounded-2xl border bg-white p-5 shadow-sm transition ${allowed ? "" : "opacity-60"}`, children: [_jsxs("div", { className: "flex items-start justify-between", children: [_jsxs("div", { children: [_jsx("h3", { className: "text-lg font-semibold", children: ENGINE_LABEL[toggle.engine_id] }), _jsx("p", { className: "mt-1 text-sm text-slate-600", children: ENGINE_DESC[toggle.engine_id] })] }), _jsx("button", { onClick: handleClick, disabled: pending, "aria-pressed": toggle.enabled, className: `relative inline-flex h-6 w-11 items-center rounded-full transition ${toggle.enabled ? "bg-emerald-500" : "bg-slate-300"} ${pending ? "opacity-50" : ""}`, children: _jsx("span", { className: `inline-block h-5 w-5 transform rounded-full bg-white shadow transition ${toggle.enabled ? "translate-x-5" : "translate-x-1"}` }) })] }), !allowed && (_jsxs("p", { className: "mt-3 text-sm text-amber-700", children: ["Not included in your ", _jsx("strong", { children: tenant.plan_tier.toUpperCase() }), " plan.", " ", _jsx("button", { onClick: onUpgradeRequired, className: "underline", children: "Upgrade" })] })), error && _jsx("p", { className: "mt-3 text-sm text-red-700", children: error }), stats && (_jsxs("dl", { className: "mt-4 grid grid-cols-3 gap-2 text-sm", children: [_jsxs("div", { children: [_jsx("dt", { className: "text-slate-500", children: "Last run" }), _jsx("dd", { className: "font-medium", children: stats.lastRun ?? "—" })] }), _jsxs("div", { children: [_jsx("dt", { className: "text-slate-500", children: "Leads (24h)" }), _jsx("dd", { className: "font-medium", children: stats.leads24h ?? "—" })] }), _jsxs("div", { children: [_jsx("dt", { className: "text-slate-500", children: "Avg score" }), _jsx("dd", { className: "font-medium", children: stats.avgScore ?? "—" })] })] }))] }));
}
